import React from 'react';

export const EcosystemBar: React.FC = () => {
  return (
    <section id="about" style={{ borderTop: '1px solid var(--fs-border)', padding: '48px 20px' }}>
      <div style={{ maxWidth: 'var(--fs-max-width)', margin: '0 auto' }}>
        <p style={{
          fontFamily: 'var(--fs-font-body)',
          fontSize: 11,
          color: 'var(--fs-text-muted)',
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          textAlign: 'center',
          marginBottom: 28,
        }}>
          Part of the Frank Ricci Design ecosystem
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 32 }}>
          <a href="https://materikadigital.com" className="fs-ecosystem-link" target="_blank" rel="noopener noreferrer" style={{ textAlign: 'center' }}>
            <span style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Materika Digital</span>
            <span style={{ display: 'block', fontSize: 11, color: 'var(--fs-text-muted)', fontWeight: 400 }}>Production-ready wrap textures. Download, open, print.</span>
          </a>
          <span style={{ width: 1, height: 40, background: 'var(--fs-border)' }} />
          <a href="https://academy.frankriccidesign.com" className="fs-ecosystem-link" target="_blank" rel="noopener noreferrer" style={{ textAlign: 'center' }}>
            <span style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>FRD Academy</span>
            <span style={{ display: 'block', fontSize: 11, color: 'var(--fs-text-muted)', fontWeight: 400 }}>The complete wrap design course. Built by someone who does the work.</span>
          </a>
          <span style={{ width: 1, height: 40, background: 'var(--fs-border)' }} />
          <a href="https://frankriccidesign.com" className="fs-ecosystem-link" target="_blank" rel="noopener noreferrer" style={{ textAlign: 'center' }}>
            <span style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>FRD.com</span>
            <span style={{ display: 'block', fontSize: 11, color: 'var(--fs-text-muted)', fontWeight: 400 }}>The studio. The portfolio. The work.</span>
          </a>
        </div>
      </div>
    </section>
  );
};
